import axios from 'axios'

export class MessageApi {
  private m_instance: any

  public constructor() {
    this.m_instance = axios.create({
      // baseURL: 'https://api.prod.photos-presse.com/message',
      baseURL: 'https://api.photos-presse.com/message',
      // baseURL: 'https://gd4lqof6ic.execute-api.us-east-1.amazonaws.com/api'
    })
  }

  public updateBaseUrl(baseUrl: string): void {
    console.log('updateBaseUrl')

    this.m_instance.defaults.baseURL = baseUrl
  }

  public updateAuthorization(token: string): void {
    console.log('updateAuthorization')

    this.m_instance.defaults.headers.common['Authorization'] = token
  }

  public pull(): Promise<JSON> {
    console.log('pull')

    return this.m_instance.get('/')
  }

  public put(payload: Record<string, string>): Promise<JSON> {
    console.log('put')

    return this.m_instance.put('/', payload)
  }
}
